<template>
  <div class="vue-modal-portal" v-if="showTheModal">
    <div class="modal-background" @click="turnModalOff">
      <div ref="modal" class="vue-modal" @click.stop>
        <div class="close-modal" @click="turnModalOff">&#10006;</div>
        <loading class="modal-loader"/>
        <portal-target name="modal" class="modal-window"/>
      </div>
    </div>
  </div>
</template>

<script>
  import {PortalTarget} from 'portal-vue'
  import {mapGetters, mapMutations} from 'vuex'
  import Loading from 'vue-src/components/global/loading'


  export default {
    name: "portal-vue-modal",
    components: {
      PortalTarget,
      Loading,
    },
    computed: {
      showTheModal() {
        let show = this.displayModal()
        if (show) {

          if (window.addEventListener) {
            window.addEventListener('DOMMouseScroll', this.theMouseWheel,
                false)
          }
          window.onmousewheel = document.onmousewheel = this.theMouseWheel
        }
        else {
          if (window.removeEventListener) {
            window.removeEventListener('DOMMouseScroll', this.theMouseWheel,
                false)
          }
          window.onmousewheel = document.onmousewheel = null
        }
        return show
      }
    },
    methods: {
      theMouseWheel(e) {
        if (this.$refs.modal.contains(e.target)) return
        e = e || window.event
        if (e.preventDefault)
          e.preventDefault()
        e.returnValue = false
      },
      ...mapGetters([
        'displayModal'
      ]),
      ...mapMutations([
        'toggleModal',
        'turnModalOn',
        'turnModalOff',
      ])
    },
    mounted() {

    },

  }
</script>

<style scoped>
  .modal-background {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgba(0, 0, 0, 0.50);
  }

  .vue-modal {
    height: 90vh;
    width: 50vw;
    min-width: 500px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
    position: relative;
    background-color: #fff;
    padding: 2em;
    max-width: 800px;
  }

  @media screen and (max-width: 992px) {
    .vue-modal {
      height: 90vh;
      width: 90vw;
      min-width: 320px;
    }
  }

  .modal-window {
    position: absolute;
    left: 2em;
    top: 2em;
    z-index: 1;
    height: calc(100% - 4em);
    width: calc(100% - 4em);
  }

  .modal-loader {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 0;
    height: 100%;
    width: 100%;
  }

  .modal-window > * {

  }

  .close-modal {
    position: absolute;
    z-index: 10;
    right: 0.25em;
    top: 0;
    font-size: 2em;
    cursor: pointer;
  }

</style>



// WEBPACK FOOTER //
// ixcms/themes/src/vue-src/top-level/portal-vue-modal.vue